// extracted by mini-css-extract-plugin
module.exports = {"cart-item":"CartItem_cart-item__2b-5z","summary":"CartItem_summary__1o1Uu","price":"CartItem_price__2J-FC","amount":"CartItem_amount__33kb6","actions":"CartItem_actions__3WQpd"};